jQuery(function($) {
    $('.member').click(function() {
        $(this).toggleClass('active');

        $('.member').not($(this)).removeClass('active');
    });
});